import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const TextField = (props) => {
    const { dataTest = '', autoComplete, label = '', input } = props;

    let extraProps = {};
    if (dataTest) extraProps['data-test'] = dataTest;
    if (autoComplete) extraProps.autoComplete = autoComplete;

    return (
        <Fragment>
            <label>{label}</label>
            <input
                key={input.name}
                className="form-control"
                type="text"
                {...input}
                {...extraProps}
                autoFocus
            />
        </Fragment>
    );
};

TextField.defaultProps = {
    label: '',
    dataTest: '',
};

TextField.propTypes = {
    label: PropTypes.string,
    input: PropTypes.shape({}).isRequired,
    dataTest: PropTypes.string,
};

export default TextField;
